import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { ProjectComponent } from './project/project.component';
import { ProjectDescriptionComponent } from './project/project-description/project-description.component';
import { ProjectArticlesComponent } from './project/project-articles/project-articles.component';
import { ProjectVolunteeringComponent } from './project/project-volunteering/project-volunteering.component';
import { RouterUrls } from '../shared/router-urls';
import { SharedModule } from '../shared/shared.module';
import { ProjectDialogComponent } from './project-dialog/project-dialog.component';
import { VoteDialogComponent } from './vote-dialog/vote-dialog.component';
import { VoteCompleteDialogComponent } from './vote-complete-dialog/vote-complete-dialog.component';
import { ReclaimVoteDialogComponent } from './reclaim-vote-dialog/reclaim-vote-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { VoteConfirmationDialogComponent } from './vote-confirmation-dialog/vote-confirmation-dialog.component';
import { BrowseProjectsComponent } from './browse-projects/browse-projects.component';
import { AboutDialogComponent } from './project/about-dialog/about-dialog.component';
import { ExternalMissionModalComponent } from './project/project-volunteering/external-mission-modal/external-mission-modal.component';
import { canActivateRoute } from '../guards/auth.guard';


const routes: Routes = [
  { path: '', component: BrowseProjectsComponent },
  { path: ':slug', component: ProjectComponent, children: [
      { path: '', pathMatch: 'full', redirectTo: RouterUrls.BrowseProjectsProjectDescription },
      { path: RouterUrls.BrowseProjectsProjectDescription, component: ProjectDescriptionComponent },
      { path: RouterUrls.BrowseProjectsProjectArticles, component: ProjectArticlesComponent },
      { path: RouterUrls.BrowseProjectsProjectVolunteering, component: ProjectVolunteeringComponent, canActivate: [canActivateRoute] },
      { path: '**', redirectTo: RouterUrls.BrowseProjectsProjectDescription }
    ]
  }
];


@NgModule({
  declarations: [
    ProjectComponent,
    ProjectDescriptionComponent,
    ProjectArticlesComponent,
    ProjectDialogComponent,
    VoteDialogComponent,
    VoteCompleteDialogComponent,
    ReclaimVoteDialogComponent,
    VoteConfirmationDialogComponent,
    BrowseProjectsComponent,
    ProjectVolunteeringComponent,
    AboutDialogComponent,
    ExternalMissionModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule
  ],
})
export class BrowseProjectsModule { }
